enum ConversationTopicType {
    Central = 1,
    Branch = 2,
    Desk = 3
}

export default ConversationTopicType;